import { DOCUMENT } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import * as i2 from '@sitemule/core/abstract-services/site-settings.service';
import { SITE_SETTINGS_SERVICE_TOKEN } from '@sitemule/core/abstract-services/site-settings.service';
import * as i1 from '@angular/platform-browser';

class SEOService {
    constructor(title, meta, siteSettingsService, _document) {
        this.title = title;
        this.meta = meta;
        this.siteSettingsService = siteSettingsService;
        this._document = _document;
    }
    setPageTitle(title) {
        const t = (() => {
            const siteName = this.siteSettingsService.siteName$.getValue();
            if (!title) {
                return siteName;
            }
            if (!siteName) {
                return title;
            }
            return `${title} - ${siteName}`;
        })();
        this.title.setTitle(t);
    }
    setPageMetaDescription(description) {
        if (description) {
            this.meta.updateTag({
                name: 'description',
                content: description,
            });
        }
        else {
            this.meta.removeTag('name="description"');
        }
    }
    setPageLanguage(language) {
        if (this._document) {
            if (language) {
                this._document.documentElement.setAttribute('lang', language);
            }
            else {
                this._document.documentElement.removeAttribute('lang');
            }
        }
    }
    setPageOGMeta(value) {
        this.setPageOGMetaType(value.type);
        this.setPageOGMetaTitle(value.title);
        this.setPageOGMetaDescription(value.description);
        this.setPageOGMetaImage(value.image);
    }
    setPageOGMetaType(value) {
        this._setPageOGMeta('type', value);
    }
    setPageOGMetaTitle(value) {
        const t = (() => {
            const siteName = this.siteSettingsService.siteName$.getValue();
            if (!value) {
                return siteName;
            }
            if (!siteName) {
                return value;
            }
            return `${value} - ${siteName}`;
        })();
        this._setPageOGMeta('title', t);
    }
    setPageOGMetaDescription(value) {
        this._setPageOGMeta('description', value);
    }
    setPageOGMetaImage(value) {
        this._setPageOGMeta('image', value);
    }
    _setPageOGMeta(key, value) {
        if (value) {
            this.meta.updateTag({
                property: `og:${key}`,
                content: value,
            });
        }
        else {
            this.meta.removeTag(`property="og:${key}"`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: SEOService, deps: [{ token: i1.Title }, { token: i1.Meta }, { token: SITE_SETTINGS_SERVICE_TOKEN }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: SEOService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.5", ngImport: i0, type: SEOService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Title }, { type: i1.Meta }, { type: i2.SiteSettingsService, decorators: [{
                    type: Inject,
                    args: [SITE_SETTINGS_SERVICE_TOKEN]
                }] }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { SEOService };
